import Home from "./Home.js"

export default Home;